<template>
  <div>
    <img src="../assets/contactbanner.jpg" class="img-fluid w-100" alt="contactbanner">
    <section class="feature-area">
      <div class="mbx">
        <div class="container">
          <div class="row">
            <div class="col-lg-9">
              <div class="nytit">联系我们</div>
            </div>
            <div class="col-lg-3">
              <div class="mbxwrap">
                <router-link to="/" class="underline">首页</router-link> <span>/</span>
                <em>联系我们</em>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
    <section class="feature-area">
      <div class="nycon">

        <div class="container">
          <div class="contact">
            <div class="ctactit">
              <h1>北京泽浩天科技发展有限公司</h1>
              <span>BEIJING ZEHAOTIAN TECHNOLOGY CO. LTD.</span>
            </div>
            <div class="ctactcon clearfix">
              <div class="ditu pull-left">
<!--                <baidu-map class="map2" :center="center" :zoom="zoom" @ready="handler"></baidu-map>-->
                <div id="map"></div>
              </div>
              <div class="ctactwrap pull-right">
                <ul>
                  <li>联系人：王经理</li>
                  <li>电话：010-67047381，010-61807868</li>
                  <li>邮箱：zehaotian@139.com</li>
<!--                  <li>手机：13810512628，13260469880</li>-->
                  <li>地址：北京市门头沟区熙旺中心A座1026 </li>
                  <li>微信号： </li>
                  <li style="padding-top: 3px">
                    <img src="/static/assets/images/qrcode.png" alt="feed">
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

</template>
<script>

// import * as BMap from "babel-plugin-transform-runtime";
import {map} from '../map.js'
  export default {
    data () {
      return {
        center: {lng: 0, lat: 0},
        zoom: 3
      }
    },
  beforeCreate() {
    window._bd_share_main = "";
  },
  mounted() {

      this.$nextTick(function(){

        var _this = this;
        map('k8MGyUzxbzCSSGkTBm6iHiBEaV3MD8Nt').then(BMap => {
          // 百度地图API功能
          var map = new BMap.Map('map',{enableMapClick:true});    // 创建Map实例
          var point = new BMap.Point(116.119752,39.941025);   //坐标拾取网址：http://api.map.baidu.com/lbsapi/getpoint/index.html
          var marker = new BMap.Marker(point);  // 创建标注


          var top_left_control = new BMap.ScaleControl({anchor: BMAP_ANCHOR_TOP_LEFT});// 左上角，添加比例尺
          var top_left_navigation = new BMap.NavigationControl();  //左上角，添加默认缩放平移控件

          marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
          map.centerAndZoom(point, 16);  // 初始化地图,设置中心点坐标和地图级别
          map.addOverlay(marker);               // 将标注添加到地图中
          map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
          map.addControl(new BMap.MapTypeControl());   //添加地图类型控件
          map.setCurrentCity("北京");          // 设置地图显示的城市 此项是必须设置的


          window.onresize = function () {

            map.centerAndZoom(point, 17);  // 重置窗口的时候 重新获取中心点坐标的位置

          }

          /*
           * 若要开启全景模式，解注
           */

          /*var stCtrl = new BMap.PanoramaControl(); //构造全景控件
          map.addTileLayer(new BMap.PanoramaCoverageLayer());
          stCtrl.setOffset(new BMap.Size(20, 20));
          map.addControl(stCtrl);//添加全景控件*/


          //添加缩放控件
          map.addControl(top_left_control);
          map.addControl(top_left_navigation);
          /*map.addControl(top_right_navigation);  */

        })
      })
//

    },
    methods:{
    }
}

</script>



// WEBPACK FOOTER //
// ContactUs.vue?43dd57d0